// Import all translation modules
import { common } from './common';
import { auth } from './auth';
import { homepage } from './homepage';
import { cars as carsModule } from './cars';
import { customer } from './customer';
import { agency } from './agency';
import { admin } from './admin';
import { dashboard } from './dashboard';
import { vehicles } from './vehicles';
import { calendar } from './calendar';
import { privacy } from './privacy';

// Create French bookings translations
export const bookings = {
  title: 'Réservations',
  subtitle: 'Gérez vos réservations de location',
  newBooking: 'Nouvelle Réservation',
  editBooking: 'Modifier la Réservation',
  customer: 'Client',
  selectCustomer: 'Sélectionner un Client',
  createNewCustomer: 'Créer un Nouveau Client',
  searchCustomer: 'Rechercher par nom ou CIN...',
  vehicle: 'Véhicule',
  selectVehicle: 'Sélectionner un Véhicule',
  startDate: 'Date de Début',
  endDate: 'Date de Fin',
  pickupTime: 'Heure de Prise en Charge',
  returnTime: 'Heure de Retour',
  depositAmount: 'Montant de la Caution',
  totalPrice: 'Prix Total',
  notes: 'Notes',
  days: 'jours',
  edit: 'Modifier',
  allStatuses: 'Tous les Statuts',
  totalBookings: '{{count}} réservation(s)',
  noBookingsFound: 'Aucune réservation trouvée',
  noBookings: 'Aucune réservation pour le moment',
  tryDifferentFilter: 'Essayez d\'ajuster votre recherche ou vos filtres',
  noBookingsDesc: 'Commencez par créer votre première réservation',
  createFirstBooking: 'Créer la Première Réservation',
  
  // Column management
  columns: 'Colonnes',
  customizeColumns: 'Personnaliser les colonnes',
  resetColumns: 'Réinitialiser',
  
  // Column labels
  car: 'Véhicule',
  dates: 'Dates',
  pickupLocation: 'Lieu de prise',
  returnLocation: 'Lieu de retour',
  damageAmount: 'Frais de dommage',
  actions: 'Actions',
  createdAt: 'Date de création',
  
  // Column groups
  bookingInformation: 'Informations de réservation',
  financialInformation: 'Informations financières',
  additionalInformation: 'Informations supplémentaires',
  
  // Filters
  activeFilters: 'Filtres actifs',
  clearAllFilters: 'Effacer tous les filtres',
  searchLabel: 'Recherche',
  statusLabel: 'Statut',
  vehicleLabel: 'Véhicule',
  periodLabel: 'Période',
  allPeriod: 'Toute la période',
  
  // Table headers
  startDateHeader: 'Date début',
  endDateHeader: 'Date fin',
  pickupTimeHeader: 'Heure de prise',
  returnTimeHeader: 'Heure de retour',
  depositHeader: 'Caution',
  damageHeader: 'Frais de dommage',
  
  // Search and placeholders
  searchVehicles: 'Rechercher des véhicules...',
  selectVehiclePlaceholder: 'Sélectionner un véhicule',
  filterByPeriodPlaceholder: 'Filtrer par période de réservation',
  selectDatePlaceholder: 'Sélectionner une date',
  timePlaceholder: 'Heure',
  timeCaption: 'Heure',
  noCustomerFound: 'Aucun client trouvé',
  
  // Client types
  individual: 'Particulier',
  company: 'Entreprise',
  
  // Error messages
  selectClientError: 'Veuillez sélectionner un client',
  selectVehicleError: 'Veuillez sélectionner un véhicule',
  selectDatesError: 'Veuillez sélectionner les dates de début et de fin',
  totalPriceError: 'Le prix total doit être supérieur à 0',
  
  status: {
    pending: 'En Attente',
    confirmed: 'Confirmée',
    completed: 'Terminée',
    cancelled: 'Annulée'
  }
};

// Create French settings translations
export const settings = {
  title: 'Paramètres',
  subtitle: 'Configurez votre agence et vos préférences',
  general: 'Général',
  business: 'Entreprise',
  notifications: 'Notifications',
  
  // General tab
  agencyInformation: 'Informations de l\'agence',
  agencyInformationDesc: 'Gérez les informations de base et l\'image de marque de votre agence',
  agencyLogo: 'Logo de l\'agence',
  uploadLogo: 'Télécharger le logo',
  logoRecommendation: 'Recommandé : 200x200px, PNG ou JPG',
  agencyName: 'Nom de l\'agence',
  agencyNamePlaceholder: 'Entrez le nom de l\'agence',
  email: 'Email',
  emailPlaceholder: 'contact@agence.com',
  phone: 'Téléphone',
  phonePlaceholder: '+33 1 23 45 67 89',
  country: 'Pays',
  countryPlaceholder: 'France',
  city: 'Ville',
  cityPlaceholder: 'Paris',
  address: 'Adresse',
  addressPlaceholder: '123 Rue Principale',
  description: 'Description',
  descriptionPlaceholder: 'Décrivez votre agence et vos services...',
  saveChanges: 'Enregistrer les modifications',
  
  // Business tab
  financialSettings: 'Paramètres financiers',
  financialSettingsDesc: 'Configurez la devise, les taux de taxe et la tarification',
  currency: 'Devise',
  selectCurrency: 'Sélectionner la devise',
  taxRate: 'Taux de taxe (%)',
  taxRatePlaceholder: '0.00',
  
  workingHours: 'Heures de travail',
  workingHoursDesc: 'Définissez les heures d\'ouverture de votre agence pour chaque jour',
  open: 'Ouvert',
  to: 'à',
  
  contractTemplate: 'Modèle de contrat',
  contractTemplateDesc: 'Modèle de contrat par défaut pour les nouvelles réservations',
  defaultContractTemplate: 'Modèle de contrat par défaut',
  contractTemplatePlaceholder: 'Entrez votre modèle de contrat par défaut ici...',
  saveBusinessSettings: 'Enregistrer les paramètres commerciaux',
  
  // Notifications tab
  notificationPreferences: 'Préférences de notification',
  notificationPreferencesDesc: 'Configurez comment et quand vous recevez les notifications',
  emailNotifications: 'Notifications par email',
  emailNotificationsDesc: 'Recevoir les notifications générales par email',
  bookingConfirmations: 'Confirmations de réservation',
  bookingConfirmationsDesc: 'Être notifié lorsque les réservations sont confirmées',
  paymentReminders: 'Rappels de paiement',
  paymentRemindersDesc: 'Recevoir des rappels pour les paiements en attente',
  maintenanceAlerts: 'Alertes de maintenance',
  maintenanceAlertsDesc: 'Recevoir des alertes pour les programmes de maintenance des véhicules',
  enabled: 'Activé',
  disabled: 'Désactivé',
  saveNotificationSettings: 'Enregistrer les paramètres de notification',
  
  // Save status messages
  saving: 'Enregistrement...',
  savedSuccessfully: 'Enregistré avec succès',
  errorSaving: 'Erreur lors de l\'enregistrement',
  
  // Days of the week
  days: {
    monday: 'Lundi',
    tuesday: 'Mardi',
    wednesday: 'Mercredi',
    thursday: 'Jeudi',
    friday: 'Vendredi',
    saturday: 'Samedi',
    sunday: 'Dimanche'
  }
};

// Export organized French translations
export const fr = {
  translation: {
    ...common,
    auth,
    homepage,
    cars: carsModule,
    carsPage: carsModule,
    customer,
    agency,
    admin,
    dashboard,
    vehicles,
    calendar,
    bookings,
    settings,
    privacy,
    
    // Override to fix naming conflict - preserve navigation keys from common
    dashboardNav: 'Tableau de bord',
    
    // Properly nest common translations under 'common' key
    common: {
      ...common,
      // Legacy keys for backward compatibility (can be removed after migration)
      comingSoon: 'Bientôt disponible',
      error: 'Erreur',
      retry: 'Réessayer',
      status: 'Statut',
    },
    
    // Agencies page translations
    agenciesPage: {
      searchAgencies: 'Rechercher des agences par nom ou ville...',
      allCities: 'Toutes les villes',
      agencyFound: 'agence trouvée',
      agenciesFound: 'agences trouvées',
      carsAvailable: 'Voitures',
      locations: 'Emplacements',
      viewDetails: 'Voir les détails',
      noAgenciesFound: 'Aucune agence trouvée',
      adjustSearchCriteria: 'Essayez d\'ajuster vos critères de recherche ou effacez les filtres pour voir plus de résultats.',
      contactForHours: 'Contactez pour les heures',
      varyingHours: 'Heures variables',
    },
  }
}; 